import { i18n } from "@translations/i18n";

import { EPermissions, IMarketingPreferencesForm } from "@features/customerDetails/ICustomerDetailsForm";

export const NUMBER_OFFER_MAX = 4;

const BASE_URL = "/";
const CART_PAGE_URL = "/cart";
const BROADBAND_PAGE_URL = "/broadband";
const BROADBAND_RESULT_PAGE_URL = `${BROADBAND_PAGE_URL}/results`;
const BROADBAND_LOGIN_PAGE_URL = "/login";
const MOBILE_PAGE_URL = "/mobile-sim-only";
const DETAILS_PAGE_URL = "/customer-details";
const INSTALLATION_PAGE_URL = "/installation";
const SUMMARY_PAGE_URL = "/summary";
const CONFIRMATION_PAGE_URL = "/confirmation";
const HELP_SUPPORT_PAGE_URL = "/help-support";

export const { MYACCOUNT_URL, ESHOP_URL, WORDPRESS_URL } = process.env;

export const ROUTES = {
    BASE_URL,
    CART_PAGE_URL,
    CONFIRMATION_PAGE_URL,
    DETAILS_PAGE_URL,
    INSTALLATION_PAGE_URL,
    BROADBAND_PAGE_URL,
    BROADBAND_RESULT_PAGE_URL,
    BROADBAND_LOGIN_PAGE_URL,
    MOBILE_PAGE_URL,
    ESHOP_URL,
    MYACCOUNT_URL,
    WORDPRESS_URL,
    SUMMARY_PAGE_URL,
    HELP_SUPPORT_PAGE_URL,
};

export const CUSTOMER_ALREADY_EXISTS = "customer-already-exists";

export const EMAIL_ALREADY_EXISTS_ERROR_CODES = ["email-prospect-already-exist", "email-user-already-exist"];

export const OFFER_CONFIG = {
    BRAND: "GOMO",
    CHANNEL: "ESHOP",
    CHANNEL_TYPE: "DIRECT",
    CUSTOMER_TYPE: "residential",
    OFFER_TYPE: "POSTPAY",
};

export const PAYMENT_TYPE_BILL = "BILL";

export const BRAND_NAME = "GoMo";

/* USER UTILS */
export const ACTIVE_CUSTOMER = "ACTIVE_CUSTOMER";

export const NO_LONGER_CUSTOMER = "NO_LONGER_CUSTOMER";

export const ALLOW_3RD_PARTIES = "ALLOW_3RD_PARTIES";

export const PERMISSION_GROUPS = [ACTIVE_CUSTOMER, NO_LONGER_CUSTOMER, ALLOW_3RD_PARTIES];

export const CONTACT_PERMISSIONS_ALL_FALSE: IMarketingPreferencesForm = {
    allowThirdParty: {
        ALLOW_EMAIL_CONTACT: false,
        ALLOW_SMS_CONTACT: false,
        ALLOW_PHONE_CONTACT: false,
        ALLOW_DIRECT_MAIL_CONTACT: false,
    },
    noLongerCustomer: {
        ALLOW_EMAIL_CONTACT: false,
        ALLOW_SMS_CONTACT: false,
        ALLOW_PHONE_CONTACT: false,
        ALLOW_DIRECT_MAIL_CONTACT: false,
    },
    activeCustomer: {
        ALLOW_EMAIL_CONTACT: false,
        ALLOW_SMS_CONTACT: false,
        ALLOW_PHONE_CONTACT: false,
        ALLOW_DIRECT_MAIL_CONTACT: false,
    },
};

export const CONTACT_PERMISSIONS_ALL_TRUE: IMarketingPreferencesForm = {
    allowThirdParty: {
        ALLOW_EMAIL_CONTACT: true,
        ALLOW_SMS_CONTACT: true,
        ALLOW_PHONE_CONTACT: true,
        ALLOW_DIRECT_MAIL_CONTACT: true,
    },
    noLongerCustomer: {
        ALLOW_EMAIL_CONTACT: true,
        ALLOW_SMS_CONTACT: true,
        ALLOW_PHONE_CONTACT: true,
        ALLOW_DIRECT_MAIL_CONTACT: true,
    },
    activeCustomer: {
        ALLOW_EMAIL_CONTACT: true,
        ALLOW_SMS_CONTACT: true,
        ALLOW_PHONE_CONTACT: true,
        ALLOW_DIRECT_MAIL_CONTACT: true,
    },
};

export const PERMISSIONS_TRADUCTION = {
    [EPermissions.ALLOW_EMAIL_CONTACT]: i18n.t("marketingPreferences:allowEmailContact"),
    [EPermissions.ALLOW_SMS_CONTACT]: i18n.t("marketingPreferences:allowSmsContact"),
    [EPermissions.ALLOW_PHONE_CONTACT]: i18n.t("marketingPreferences:allowPhoneContact"),
    [EPermissions.ALLOW_DIRECT_MAIL_CONTACT]: i18n.t("marketingPreferences:allowDirectMailContactDirect"),
};

export const HELP_SUPPORT_URL = `${WORDPRESS_URL}/help-support/`;

export const EIRCODE_FINDER_URL = "https://finder.eircode.ie/#/";

export const PAYMENT_TYPE = [
    { value: "BILL_PAY_SINGLE_LINE", label: "Bill Pay (1 SIM)" },
    { value: "BILL_PAY_MULTI_LINE", label: "Bill Pay (2+ SIMs)" },
    { value: "PAYG_REGISTERED", label: "Prepay registered" },
    { value: "PAYG_UNREGISTERED", label: "Prepay unregistered" },
];

export const PAYMENT_STANCER_URL = "https://payment.stancer.com";

export const PAYMENT_AUTHENTICATION_REQUIRED = "payment-authentication-required";

export enum EHttpCode {
    BAD_REQUEST = 400,
}

export enum EAcquisitionType {
    NEW_ACQUISITION = "NEW_ACQUISITION",
    CROSS_SELL = "CROSS_SELL",
}

export enum EServiceGroup {
    MOBILE = "MOBILE",
    SA_BB = "SA_BB",
}

export enum EServiceTechnology {
    FTTC = "FTTC", // broadband fiber to the cabinet
    FTTH = "FTTH", // fiber to the home
    NBI = "NBI", // fiber by the government
    VOBB = "VOBB", // Voice over broadband
    NGB = "NGB", // broadband adsl
    MBB = "MBB", // mobile broadband
    PSTN = "PSTN", // fixe
    SABB = "SABB", // stand-alone broadband
    LSH = "LSH",
    BS = "BS",
    VC = "VC",
    BEA = "BEA",
    VEA = "VEA",
    GEA = "GEA",
}

export enum EAppointmentType {
    NO_INSTALL = "NO_INSTALL",
    FULL_INSTALL = "FULL_INSTALL",
    OPTIONAL_INSTALL = "OPTIONAL_INSTALL",
}

export enum EAppointmentSlot {
    AD = "AD",
    AM = "AM",
    PM = "PM",
}

export const DEFAULT_NEXT_ACTIVATION_DATE = 3;
